
import Vue from 'vue'
import Logo from './components/Logo.vue'
import ProfileSection from './components/ProfileSection.vue'
import ToolbarTitle from './components/ToolbarTitle.vue'
import isProduction from '@/mixins/crud/computed/isProduction'

export default Vue.extend({
  components: {
    Logo,
    ToolbarTitle,
    ProfileSection,
  },

  mixins: [isProduction],

  props: ['drawer', 'currentRouteName'],
  methods: {
    openSupportInNewTab() {
      const url = 'https://master.ffe.gg'
      console.log(url)
      window.open(url, '_blank')
    },
  },
})
